module.exports = __webpack_public_path__ + "media/images/opengraph-204e3de0.jpg";